import Vue from 'vue';
import { Base64 } from 'js-base64';
import axios from 'axios';
import DeviceType from '@/models/device-type';
import LoginService from '@/services/login.service.js';
import HttpCode from '@/models/http-code.js';
import HttpStatus from '@/models/http-status.js';
import { getCurrentTimestamp } from '@/utils/utils.js';

axios.defaults.headers.post['Content-Type'] = 'application/json';

function httpHeaders(isWebChatLogin = false) {
    return {
        'Access-Control-Allow-Origin': axios.defaults.baseURL,
        DeviceType: DeviceType.Web,
        AuthType: isWebChatLogin ? DeviceType.WeChat : DeviceType.Web,
        UserId: LoginService.userInfo && LoginService.userInfo.ObjectID ?
            LoginService.userInfo.ObjectID : '',
    };
}

function httpTokenHeaders(tokenId) {
    return {
        'Access-Control-Allow-Origin': axios.defaults.baseURL,
        DeviceType: DeviceType.Web,
        TokenID: tokenId || '',
    };
}

function setS2WebSite() {
    const s2WebSiteStr = JSON.stringify({
        apiUrl: Vue.prototype.$apiURL,
    });
    localStorage.setItem('S2WebSite', Base64.encode(s2WebSiteStr));
}

function successHandle(res) {
    const data = res.data;
    if (data.hasOwnProperty('Code')) {
        data.Success = data.Code === HttpCode.Success && data.Status === HttpStatus.Success;

        //处理License
        if (data.Code === HttpCode.LicenseError) {
            Vue.prototype.$alert(data.Message, 'License提示', {
                confirmButtonText: '确定',
                callback: () => {
                    if (LoginService.userInfo && LoginService.userInfo.isAdministrator) {
                        window.location.href = '/backstage/system-manage/licenseset';
                    } else {
                        LoginService.logout(this.$route.fullPath);
                    }
                },
            });
            //弹窗提示，不再单独弹小窗
            return {
                Code: 200,
                Result: {},
                Status: 0,
                Success: true,
            };
        }
    }
    return data;
}

function errorHandle(error) {
    if(error.ExceptionSeqNo){return;} //此类异常已拦截抛出

    let meesage = '后台异常';
    if (error && error.request) {
        const status = error.request.status;
        if (status == 0) {
            meesage = '未请求到网络连接';
        }
    }
    return {
        Success: false,
        Message: meesage,
    };
}

const http = {
    async loadAppJson() {
        if (Vue.prototype.$apiURL) {
            return new Promise(resolve => {
                resolve();
            });
        } else if (process.env.VUE_APP_URL_REDIRECT === '1') {
            const { data } = await axios.get('/app.json');
            if (data.URLType === '1') {
                axios.defaults.baseURL = data.ApiUrlNew;
                Vue.prototype.$apiURL = data.ApiUrlNew;
                Vue.prototype.$webURL = data.VueUrlNew;
                Vue.prototype.$mobileURL = data.MobileURLNew;
            } else {
                axios.defaults.baseURL = data.ApiUrl;
                Vue.prototype.$apiURL = data.ApiUrl;
                Vue.prototype.$webURL = data.VueUrl;
                Vue.prototype.$mobileURL = data.MobileURL;
            }
            Vue.prototype.$webVersion = data.WebVersion;
            // if (IsNull(data.WebVersionInfoURL)) {
                Vue.prototype.$webVersionInfoURL = process.env.VUE_APP_WEBVERSIONINFO;
            // } else {
            //     Vue.prototype.$webVersionInfoURL = data.WebVersionInfoURL;
            // }
            setS2WebSite();
        } else {
            return new Promise(resolve => {
                axios.defaults.baseURL = process.env.VUE_APP_APIURL;
                Vue.prototype.$apiURL = process.env.VUE_APP_APIURL;
                Vue.prototype.$webURL = process.env.VUE_APP_WEBURL;
                Vue.prototype.$webVersion = process.env.VUE_APP_WEBVERSION;
                Vue.prototype.$webVersionInfoURL = process.env.VUE_APP_WEBVERSIONINFO;
                Vue.prototype.$mobileURL = process.env.VUE_APP_MOBILEURL;
                setS2WebSite();
                resolve();
            });
        }
    },
    /**
     *
     * @param url
     * @param parameters
     * @param responseType
     * @param isWebChatLogin
     * @param axiosSource   使用时用getCancelableSource生成,用于取消axios请求
     * @returns {Promise<{Status, Code, Success, Result}|*|{Message: string, Success: boolean}|any>}
     * @constructor
     */
    async POST(url, parameters, responseType, isWebChatLogin = false, axiosSource) {
        await this.loadAppJson();
        try {
            const res = await axios.post(url, parameters, {
                headers: httpHeaders(isWebChatLogin),
                responseType: responseType ? responseType : 'json',
                cancelToken: axiosSource ? axiosSource.token : undefined,
            });
            LoginService.setTime();
            if (responseType === 'blob') {
                return res;
            } else {
                return successHandle(res);
            }
        } catch (error) {
            return errorHandle(error);
        }
    },
    async LoginByToken(url, parameters, tokenId, responseType) {
        await this.loadAppJson();
        try {
            const res = await axios.post(url, parameters, {
                headers: httpTokenHeaders(tokenId),
                responseType: responseType ? responseType : 'json',
            });
            return successHandle(res);
        } catch (error) {
            return errorHandle(error);
        }
    },
    async GET(url, responseType, axiosSource) {
        await this.loadAppJson();
        try {
            const res = await axios.get(url, {
                headers: httpHeaders(),
                responseType: responseType ? responseType : 'json',
                cancelToken: axiosSource ? axiosSource.token : undefined,
                params: {
                    random: getCurrentTimestamp(),
                },
            });
            LoginService.setTime();
            return successHandle(res);
        } catch (error) {
            return errorHandle(error);
        }
    },
    async HttpFileUpload(url, file, formDatas) {
        await this.loadAppJson();
        let formData = new FormData();
        formData.append('file', file, 'file');
        if (formDatas) {
            formData.append('formDatas', JSON.stringify(formDatas));
        }
        try {
            const res = await axios.post(url, formData, {
                headers: {
                    ...httpHeaders(),
                    Accept: 'application/json',
                },
                responseType: 'json',
            });
            return successHandle(res);
        } catch (error) {
            return errorHandle(error);
        }
    },
    async loadRuleJson() {
        const baseURL = axios.defaults.baseURL;
        try {
            axios.defaults.baseURL = ''; //取资源文件路径
            const res = await axios.get('/static/json/FormulaCalculator.json');
            axios.defaults.baseURL = baseURL;
            return res.data;
        } catch (error) {
            axios.defaults.baseURL = baseURL;
            return {
                Success: false,
                Message: '读取json失败!',
            };
        }
    },
    getCancelableSource() {
        let CancelToken = axios.CancelToken;
        return CancelToken.source();
    },
};

export default http;
